export class EvidenceDto  {
  docEvidenceId: number = -1;
  evidenceType?: string ;
  testresult?: number ;
  validFrom?: string ;
  validTo?: string;
}
